import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import api from 'utils/api';
export function fetchUserTeams(_x) {
  return _fetchUserTeams.apply(this, arguments);
}
function _fetchUserTeams() {
  _fetchUserTeams = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(teamIds) {
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", api('get', '/api/query/userTeams', {
            fields: ['user_id'],
            filter: {
              team_id: teamIds
            }
          }));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _fetchUserTeams.apply(this, arguments);
}